<script lang="ts" setup>
    import Invoice from '~/app/invoicing/models/Invoice';

    interface Props {
        content: Invoice;
        index?: number;
    }

    interface Emits {
        (e: 'click', invoice: Invoice): void;
        (e: 'contextmenu', invoice: Invoice, event: MouseEvent): void;
    }

    const props = defineProps<Props>();
    const emit = defineEmits<Emits>();

    const handleClick = () => {
        emit('click', props.content);
    };

    const handleContextMenu = (event: MouseEvent) => {
        emit('contextmenu', props.content, event);
    };

    const animationDelay = computed(() => {
        return props.index !== undefined ? `${props.index * 0.1 + 0.05}s` : '0s';
    });
</script>

<template>
    <article
        class="@container flex items-center w-full gap-3 py-2.5 @xl:py-4 text-sm transition-all cursor-pointer hover:bg-neutral-100 px-[10px] rounded-[10px] animate-appear border-t border-gray-100"
        :style="{ animationDelay }"
        @click.prevent="handleClick"
        @contextmenu="handleContextMenu"
    >
        <!-- Invoice info -->
        <div class="shrink-0 min-w-[15%]">
            <h3 :class="$theme('dashboard.itemTitle')">
                {{ content.number }}
            </h3>
            <p
                v-if="content.dueAt"
                :class="$theme('dashboard.subtitle')"
                class="block"
            >
                {{ content.dueAt.format('DD/MM/YYYY') }}
            </p>
        </div>

        <!-- Contact name -->
        <div
            v-if="content.contact"
            class="flex-1 min-w-0 @xl:min-w-[250px] truncate"
        >
            <span
                :class="$theme('dashboard.itemTitle')"
                class="font-medium"
            >
                {{ content.contact?.displayName }}
            </span>
        </div>

        <!-- Total amount + status badge -->
        <div class="flex flex-col items-end gap-1 ml-auto shrink-0 @xl:flex-row @xl:items-center @xl:gap-0">
            <div
                v-if="content.total"
                :class="$theme('dashboard.itemTitle')"
                class="w-[100px] text-right @xl:mr-5"
            >
                {{ $price(content.total) }}
            </div>

            <div class="w-[100px] flex justify-end @xl:justify-start">
                <UiStatusBadge
                    translation-prefix="invoice_status"
                    :status="content.status"
                />
            </div>
        </div>
    </article>
</template>
